import React from 'react'

import NavbarHeader from '../../../Navbarheader/NavbarHeader';
import Footer from '../../../Footer/Footer';
import Herosection from './components/Herosection';

import './Adept.css'
import Designprocess from './components/Designprocess';
import Discovertitle from './components/discover/Discovertitle';
import Contextualfinding from './components/discover/Contextualfinding';
import Aims from './components/discover/Aims';
import Quantitative from './components/discover/Quantitative';
import Qualitative from './components/discover/Qualitative';
import Insight from './components/discover/Insight';
import Definetitle from './components/define/Definetitle';
import Userpersonaone from './components/define/Userpersonaone';
import Userpersonatwo from './components/define/Userpersonatwo';
import Empathymappingone from './components/define/Empathymappingone';
import Empathymappingtwo from './components/define/Empathymappingtwo';
import Problemstatement from './components/define/Problemstatement';
import Designtitle from './components/design/Designtitle';
import Brainstorming from './components/design/Brainstorming';
import Affinitymapping from './components/design/Affinitymapping';
import Informationarchitecture from './components/design/Informationarchitecture';
import Wireframe from './components/design/Wireframe';
import Delivertitle from './components/deliver/Delivertitle';
import Color from './components/deliver/Color';
import Typography from './components/deliver/Typography';
import Hifi from './components/deliver/Hifi';
import BannerOne from './components/BannerOne';

import NextProjectButton from "../components/NextProjectButton";
import { useNavigate } from 'react-router-dom';



function Adept() {

  const navigate = useNavigate()

  const handleNextProjectClick = () => {
   
      navigate('/project/buidl');
    
  };


  return (
    <div fluid  className="scroll-container">
    <NavbarHeader />
     <Herosection />

    {/* discover */}
     <Designprocess />
     <br/>
     <Discovertitle />
     <Contextualfinding />
     <Aims />
     <Quantitative />
     <Qualitative />
     <Insight />

     {/* define */}
     <Definetitle />
     <Userpersonaone />
     <Empathymappingone />
     <Userpersonatwo />
     <Empathymappingtwo />
     <Problemstatement />
     <br/>

     {/* design */}
     <Designtitle />
     <Brainstorming />
     <Affinitymapping />
     <Informationarchitecture />
     <Wireframe />

     {/* Deliver */}
     <Delivertitle />
     <Color />
     <Typography />
     <Hifi />
     <div id='showNextButton'><BannerOne /></div>
     

    
     
    <Footer />

    <NextProjectButton 
        sectionId="showNextButton" 
        onClick={handleNextProjectClick} 
      />
  </div>
  )
}

export default Adept
